import { FC } from 'react';
import { useTranslation } from 'src/pages/error/i18n';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from 'material-hu';
import { formatTitle } from 'src/utils/helmetUtils';
import humandLogo from 'src/assets/humand.svg';

export const Maintenance: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{formatTitle(t('MAINTENANCE_PAGE_TITLE'))}</title>
      </Helmet>
      <Container
        maxWidth="xl"
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          component="img"
          alt="Humand"
          src={humandLogo}
          sx={{
            height: '48px',
            width: 'auto',
            marginBottom: 3,
          }}
        />
        <Typography
          component="h5"
          sx={{
            fontSize: '24px',
            fontWeight: '700',
            lineHeight: '29px',
            letterSpacing: '0px',
            textAlign: 'center',
            marginBottom: 1,
          }}
        >
          {t('MAINTENANCE_TITLE')}
        </Typography>
        <Typography
          component="span"
          sx={{
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '24px',
            letterSpacing: '0px',
            textAlign: 'center',
            color: 'text.secondary',
          }}
        >
          {t('MAINTENANCE_DESCRIPTION')}
        </Typography>
      </Container>
    </>
  );
};

export default Maintenance;
